/**
 * A small, muted trust line shown beneath the composer wherever the couple can
 * chat with Éros (the focus page, the planner conversation, the drawer) — the
 * standard "AI can make mistakes, check the results" disclaimer. Kept quiet
 * (caption + text.disabled, centered) so it reassures without pulling focus.
 */

import { Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

interface AssistantDisclaimerProps {
  /** Layout-only overrides from the call site (spacing, padding). */
  sx?: SxProps<Theme>;
}

const AssistantDisclaimer = ({ sx }: AssistantDisclaimerProps) => {
  const { t } = useTranslation();

  return (
    <Typography
      variant="caption"
      sx={{
        display: 'block',
        textAlign: 'center',
        color: 'text.disabled',
        lineHeight: 1.4,
        ...sx,
      }}
    >
      {t('assistant.disclaimer')}
    </Typography>
  );
};

export default AssistantDisclaimer;
